(() => {
  'use strict';
  const root = document.getElementById('lc-bridal');
  if (!root || root.dataset.initialized) return;
  let text;
  try {
    text = JSON.parse(root.dataset.plannerCopy || '{}');
  } catch {
    return;
  }
  if (!text.labels || !text.focuses || !text.intros || !text.titles) return;
  root.dataset.initialized = 'true';
  let timing = 'season';
  let focus = 'lpg';
  function update() {
    root.querySelectorAll('[data-time]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.time === timing));
    });
    root.querySelectorAll('[data-focus]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.focus === focus));
    });
    let title = text.titles[focus];
    let copy = text.intros[timing];
    if (focus === 'facials' && timing === 'season') copy = text.facials_season;
    if (focus === 'facials' && timing === 'soon') copy = text.facials_soon;
    if (focus === 'body' && timing !== 'close') copy += text.body_extra;
    if (timing === 'close') title = text.titles.close;
    root.querySelector('#lc-result-title').textContent = title;
    root.querySelector('#lc-result-copy').textContent = copy;
    root.querySelector('#lc-selected-note').textContent = text.selected
      .replace('{focus}', text.focuses[focus])
      .replace('{timing}', text.labels[timing]);
    root.querySelector('#lc-next-copy').textContent = timing === 'close' ? text.next_close : text.next;
  }
  root.querySelectorAll('[data-time]').forEach(button => {
    button.addEventListener('click', () => {
      timing = button.dataset.time;
      update();
    });
  });
  root.querySelectorAll('[data-focus]').forEach(button => {
    button.addEventListener('click', () => {
      focus = button.dataset.focus;
      update();
    });
  });
  root.querySelectorAll('.select-plan').forEach(button => {
    button.addEventListener('click', () => {
      focus = button.dataset.plan;
      update();
      root.querySelector('#lc-begin').scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });
  });
  update();
})();
